import { create } from "zustand";
import { GetSuppliesParams } from "~/services/supply";

type State = {
  formState: {
    open: boolean;
    supplyId?: string;
  };
  filters: GetSuppliesParams;
  showLowStock: boolean;
};

type Actions = {
  setFilters: (filters: GetSuppliesParams) => void;
  resetFilters: () => void;
  openSupplyModal: (supplyId?: string) => void;
  closeSupplyModal: () => void;
  setShowLowStock: (showLowStock: boolean) => void;
};

const initialState: GetSuppliesParams = {
  category: "",
  search: "",
  page: 1,
  pageSize: 10,
};

export const useSupplyStore = create<State & Actions>()((set) => ({
  formState: {
    open: false,
  },
  filters: initialState,
  showLowStock: false,
  setFilters: (filters) =>
    set((state) => ({
      filters: {
        ...state.filters,
        ...filters,
      },
    })),
  resetFilters: () => set({ filters: initialState }),
  openSupplyModal: (supplyId) =>
    set({
      formState: {
        open: true,
        supplyId,
      },
    }),
  closeSupplyModal: () =>
    set({ formState: { open: false, supplyId: undefined } }),
  setShowLowStock: (showLowStock) =>
    set(() => ({
      showLowStock,
    })),
}));
